export const FIREBASE_AUTH_ERROR = {
  userNotFound: 'auth/user-not-found',
  wrongPassword: 'auth/wrong-password',
}
